import { render, staticRenderFns } from "./OrganizationView.vue?vue&type=template&id=38dd612d&scoped=true&"
import script from "./OrganizationView.vue?vue&type=script&lang=js&"
export * from "./OrganizationView.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationView.vue?vue&type=style&index=0&id=38dd612d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd612d",
  null
  
)

export default component.exports